
import Vue from 'vue';
import Component from 'vue-class-component';
import Course from './course.vue';

@Component({
  components: { Course }
})
export default class OnLineClassHome extends Vue {
  // keyword: string = '123';

  // handleSearch() {
  //   (this.$refs.search as HTMLFormElement).handleSearch();
  // }
}
